/**
 * Обёртка карточки услуги (02_GPT-MODULAR).
 */

import "./ServiceCard.css";
import "./ServiceCardVariants.css";
import "./ServiceCardAi.css";
import "./ServiceCardCode.css";
import "./ServiceCardCodeAnim.css";

function ServiceCard({ variant, className = "", children, ...rest }) {
    const variantClass = variant ? ` group-9__card_${variant}` : "";
    const extra = className ? ` ${className}` : "";

    return (
        <article className={`group-9__card${variantClass}${extra}`} {...rest}>
            {children}
        </article>
    );
}

export default ServiceCard;
// components/ServiceCard/ServiceCard.js
